import { ChangeDetectionStrategy, Component, viewChild } from '@angular/core';
import { SwiperModule, SwiperSlideDirective } from 'swiper/angular';

@Component({
  standalone: true,
  selector: 'accredible-carousel-item',
  imports: [SwiperModule],
  templateUrl: './carousel-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccredibleCarouselItemComponent {
  data = viewChild(SwiperSlideDirective);
}
